import commonService from "./common.service";

/**
 * Phase 7 Procurement-as-a-Service catalogue + pricing + requests + billing.
 * Backend routes are mounted at:
 *   - `/api/v1/p2p/admin/...` (super admin only)
 *   - `/api/v1/p2p/services/...` (any authenticated tenant user)
 */

const ADMIN_BASE = "/p2p/admin";
const USER_BASE = "/p2p/services";

const p2pProcurementServiceService = {
  // --- Super-admin: services ----------------------------------------------
  adminListServices: () => commonService.get(`${ADMIN_BASE}/platform-services`),
  adminCreateService: (payload) =>
    commonService.post(`${ADMIN_BASE}/platform-services`, payload),
  adminUpdateService: (serviceId, payload) =>
    commonService.put(`${ADMIN_BASE}/platform-services/${serviceId}`, payload),

  // --- Super-admin: pricing -----------------------------------------------
  adminListPricing: (serviceId) =>
    commonService.get(`${ADMIN_BASE}/platform-services/${serviceId}/pricing`),
  adminCreatePricing: (serviceId, payload) =>
    commonService.post(
      `${ADMIN_BASE}/platform-services/${serviceId}/pricing`,
      payload
    ),
  adminUpdatePricing: (pricingId, payload) =>
    commonService.put(
      `${ADMIN_BASE}/platform-service-pricing/${pricingId}`,
      payload
    ),

  // --- Super-admin: requests + billing ------------------------------------
  adminListServiceRequests: () =>
    commonService.get(`${ADMIN_BASE}/service-requests`),
  adminUpdateRequestStatus: (requestId, payload) =>
    commonService.put(
      `${ADMIN_BASE}/service-requests/${requestId}/status`,
      payload
    ),
  adminCreateBilling: (requestId, payload) =>
    commonService.post(
      `${ADMIN_BASE}/service-requests/${requestId}/billing`,
      payload
    ),
  adminUpdateBilling: (billingId, payload) =>
    commonService.put(`${ADMIN_BASE}/service-billing/${billingId}`, payload),

  // --- Tenant user --------------------------------------------------------
  getCatalogue: () => commonService.get(`${USER_BASE}/catalogue`),
  getCatalogueDetail: (serviceId) =>
    commonService.get(`${USER_BASE}/catalogue/${serviceId}`),
  createRequest: (payload) => commonService.post(`${USER_BASE}/request`, payload),
  listMyRequests: () => commonService.get(`${USER_BASE}/my-requests`),
  getMyRequest: (requestId) =>
    commonService.get(`${USER_BASE}/my-requests/${requestId}`),
  listBillingForRequest: (requestId) =>
    commonService.get(`${USER_BASE}/my-requests/${requestId}/billing`),
  cancelMyRequest: (requestId, payload) =>
    commonService.put(`${USER_BASE}/my-requests/${requestId}/status`, payload),
};

export default p2pProcurementServiceService;
